import React from "react";

const variantClasses = {
  h1: "font-medium sm:text-[48px] md:text-[48px] text-[72px]",
  h2: "sm:text-[40px] md:text-[46px] text-[50px]",
  h3: "font-semibold sm:text-[32px] md:text-[34px] text-[36px]",
  h4: "sm:text-[28px] md:text-[30px] text-[32px]",
  h5: "sm:text-[22px] md:text-[24px] text-[26px]",
  h6: "sm:text-[20px] md:text-[22px] text-[24px]",
  body1: "font-medium text-[20px]",
  body2: "font-bold text-[18px]",
  body3: "text-[16px]",
  body4: "font-normal text-[15.23px]",
  body5: "font-bold text-[15px]",
  body6: "text-[14px]",
  body7: "font-normal text-[12px]",
  body8: "font-normal text-[11px]",
};

const Text = ({ children, className, variant, as, ...restProps }) => {
  const Component = as || "span";
  return (
    <Component
      className={`${className} ${variant && variantClasses[variant]}`}
      {...restProps}
    >
      {children}
    </Component>
  );
};

export { Text };
